import Modal from 'react-modal'
import styled from 'styled-components'

import { mediaQueries, palette } from '../../styles/variables'
import { CloseButton } from '../buttons/Buttons'
import { Text } from '../topography'
import { isEnterpriseAdmin } from '../../utils/userAuth'
import { MODAL_CONTENT } from '../../containers/AdministratorDashboard/consts/texts'

import Title from './checkoutModal/common/Title'

const ModalContent = styled.div({
  padding: '18px 32px 20px 25px',
  position: 'relative',
  height: 'fit-content',
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  boxSizing: 'border-box',
  backgroundColor: palette.white,
  [mediaQueries.mobile]: {
    minHeight: 'unset',
  },
  '@media (pointer:none), (pointer:coarse)': {
    padding: '72px 32px 44px 32px',
  },
})

export default ({ isOpen, onClose, overlayStyle }) => {
  const { title, text } = isEnterpriseAdmin()
    ? MODAL_CONTENT.enterpriseAdmin
    : MODAL_CONTENT.enterpriseUser
  return (
    <Modal
      isOpen={isOpen}
      style={{
        overlay: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxHeight: '100vh',
          ...overlayStyle,
        },
        content: {
          border: 'none',
          padding: 0,
          width: '95%',
          maxWidth: '800px',
          height: '250px',
          maxHeight: '90vh',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'stretch',
          justifyContent: 'stretch',
          position: 'relative',
          inset: 'auto',
          overflowY: 'auto',
          backgroundColor: palette.gray10,
        },
      }}
    >
      <CloseButton onClick={onClose} styles={{ top: '20px', zIndex: '999' }} />
      <ModalContent>
        <Title>{title}</Title>
        <Text
          margin="80px 0px"
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      </ModalContent>
    </Modal>
  )
}
